import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;


export function getUserSpentTimeDataTable(data) {
    return fetch({
      url: apiUrl + '/api/Report/GetUserSpentTimeDataTable',
      method: 'post',
      data
    })
  }

  export function exportUserSpentTimeDataTable(data) {
    return fetch({
      url: apiUrl + '/api/Report/ExportUserSpentTimeDataTable',
      method: 'post',
      data
    })
  }

//   export function getDailyWeeklyReportSpentTimeDataTableGroupByUserAndTaskType(data) {
//     return fetch({
//       url: apiUrl + '/api/Report/GetDailyWeeklyReportSpentTimeDataTableGroupByUserAndTaskType',
//       method: 'post',
//       data
//     })
//   }
  
//   export function exportDailyWeeklyReportSpentTimeGroupByUserAndTaskType(data){
//     return fetch({
//       url: apiUrl + '/api/Report/ExportDailyWeeklyReportSpentTimeGroupByUserAndTaskType',
//       method: 'post',
//       data
//     })
//   }
  
  export function getUserWeeklyReportStatusListByMonth(data) {
    return fetch({
      url: apiUrl + '/api/Report/GetUserWeeklyReportStatusListByMonth',
      method: 'post',
      data
    })
  }
  //导出
//   export function exportToExcelWeeklyReportCompleteListByUser(data) {
//     return fetch({
//       url: apiUrl + '/api/Report/ExportToExcelWeeklyReportCompleteListByUser',
//       method: 'post',
//       data
//     })
//   }

//   export function exportToExcelWeeklyReportSpentTimeGroupByUserAndDateRange(data) {
//     return fetch({
//       url: apiUrl + '/api/Report/ExportToExcelWeeklyReportSpentTimeGroupByUserAndDateRange',
//       method: 'post',
//       data
//     })
//   }

  // export function apiExportToExcelWeeklyReportSpentTimeGroupByUser(data) {
  //   return fetch({
  //     url: apiUrl + '/api/Report/ExportToExcelWeeklyReportSpentTimeGroupByUser',
  //     method: 'post',
  //     data
  //   })
  // }
  
  
  // export function apiGetWeeklyReportSpentTimeDataTableGroupByUser(data) {
  //     return fetch({
  //       url: apiUrl + '/api/Report/GetWeeklyReportSpentTimeDataTableGroupByUser',
  //       method: 'post',
  //       data
  //     })
  //   }
    
    // export function apiExportToExcelWeeklyReportSpentTimeGroupByUser(data) {
    //   return fetch({
    //     url: apiUrl + '/api/Report/ExportToExcelWeeklyReportSpentTimeGroupByUser',
    //     method: 'post',
    //     data
    //   })
    // }
  
    
  export function getProjectSpentTimeDataTableByUser(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetProjectSpentTimeDataTableByUser',
        method: 'post',
        data
      })
    }
    
    export function exportProjectSpentTimeDataTableByUser(data) {
      return fetch({
        url: apiUrl + '/api/Report/ExportProjectSpentTimeDataTableByUser',
        method: 'post',
        data
      })
    }
  
  
    export function getTaskSpentTimeDataTableByUser(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetTaskSpentTimeDataTableByUser',
        method: 'post',
        data
      })
    }

    export function exportTaskSpentTimeDataTableByUser(data) {
      return fetch({
        url: apiUrl + '/api/Report/ExportTaskSpentTimeDataTableByUser',
        method: 'post',
        data
      })
    }
  
    export function getMonthlySpentTimeDataTableGroupByTask(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetMonthlySpentTimeDataTableGroupByTask',
        method: 'post',
        data
      })
    }

    export function exportMonthlySpentTimeDataTableGroupByTask(data) {
      return fetch({
        url: apiUrl + '/api/Report/ExportMonthlySpentTimeDataTableGroupByTask',
        method: 'post',
        data
      })
    }

    
    //统计任务的月度工时投入数据
    //汇总所有任务
    export function getMonthlySpentTimeDataTableGroupByAllTask(data) {
      return fetch({
        url: apiUrl + '/api/Report/getMonthlySpentTimeDataTableGroupByAllTask',
        method: 'post',
        data
      })
    }

    //统计指定项目人员工时投入数据
export function getUserSpentTimeDataTableGroupByProject(data) {
    return fetch({
      url: apiUrl + '/api/Report/GetUserSpentTimeDataTableGroupByProject',
      method: 'post',
      data
    })
  }

  

      //统计指定项目部门工时投入数据
export function getOrganizationSpentTimeDataTableGroupByProject(data) {
  return fetch({
    url: apiUrl + '/api/Report/GetOrganizationSpentTimeDataTableGroupByProject',
    method: 'post',
    data
  })
}
  
  //统计项目的月度工时投入数据
  export function getMonthlySpentTimeDataTableGroupByProject(data) {
    return fetch({
      url: apiUrl + '/api/Report/GetMonthlySpentTimeDataTableGroupByProject',
      method: 'post',
      data
    })
  }

  export function exportMonthlySpentTimeDataTableGroupByProject(data) {
    return fetch({
      url: apiUrl + '/api/Report/ExportMonthlySpentTimeDataTableGroupByProject',
      method: 'post',
      data
    })
  }

    //统计项目的月度工时投入数据
    //汇总所有项目
    export function getMonthlySpentTimeDataTableGroupByAllProject(data) {
      return fetch({
        url: apiUrl + '/api/Report/getMonthlySpentTimeDataTableGroupByAllProject',
        method: 'post',
        data
      })
    }

    //获取指定项目的统计信息
    export function getProjectReportData(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetProjectReportData',
        method: 'post',
        data
      })
    }


    
    //获取指定任务的统计信息
    export function getTaskReportData(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetTaskReportData',
        method: 'post',
        data
      })
    }

        //统计指定任务部门工时投入数据
export function getOrganizationSpentTimeDataTableGroupByTask(data) {
          return fetch({
            url: apiUrl + '/api/Report/getOrganizationSpentTimeDataTableGroupByTask',
            method: 'post',
            data
          })
        }

        //统计指定任务人员工时投入数据
        export function getUserSpentTimeDataTableGroupByTask(data) {
          return fetch({
            url: apiUrl + '/api/Report/GetUserSpentTimeDataTableGroupByTask',
            method: 'post',
            data
          })
        }

//统计项目工时数据
export function getProjectSpentTimeDataTable(data) {
  return fetch({
       url: apiUrl + '/api/Report/GetProjectSpentTimeDataTable',
       method: 'post',
       data
    })
  }

  
//统计任务工时数据
export function getTaskSpentTimeDataTable(data) {
  return fetch({
       url: apiUrl + '/api/Report/GetTaskSpentTimeDataTable',
       method: 'post',
       data
    })
  }


    //获取指定用户的统计信息
    export function getUserReportData(data) {
      return fetch({
        url: apiUrl + '/api/Report/GetUserReportData',
        method: 'post',
        data
      })
    }


// WEBPACK FOOTER //
// ./src/api/reportApi.js